// import classNames from "classnames";
import { BlogPostGrid } from "components/Blog";
import Layout from "components/Layout";
import { VerticalNavBar } from "components/NavBar/VerticalNavBar";
import { NavBarCmsData } from "components/NavBar/interfaces";
import { AlignedRichText } from "components/RichText";
import Spacer from "components/Spacer";
import { BlogPostsSubBlock, StreamfieldBlock } from "interfaces";
import { EmtekPageProps } from "pages/[[...slug]]";

import { BlockWidthProvider } from "./SplitLayoutSubPage";
import { Toolbox, ToolboxBlock } from "./Toolbox";

import styles from "./blog-post.module.scss";

type RecommendedBlogPostsBlock = StreamfieldBlock<
    "recommended_blog_posts",
    { title: string; posts: BlogPostsSubBlock[] }
>;

export type PageProps = EmtekPageProps<{
    body: (ToolboxBlock | StreamfieldBlock<"rich_text", string>)[];
    blog_categories: string[] | null;
    first_published_at: string;
    post_description: string;
    split_layout_nav: NavBarCmsData | null;
    additional_body_content: (ToolboxBlock | RecommendedBlogPostsBlock)[];
}>;

const BlogPost: React.FC<PageProps> = (props) => {
    return (
        <Layout
            metadata={props.wagtail}
            menus={props.menus}
            //  promo={props.promo}
        >
            <div className={styles.layout}>
                {props.wagtail.split_layout_nav && (
                    <div className={styles.layoutNav}>
                        <VerticalNavBar
                            cmsData={props.wagtail.split_layout_nav}
                        />
                    </div>
                )}
                <div className={styles.layoutBody}>
                    <header className={styles.postInfoContainer}>
                        {props.wagtail.blog_categories && (
                            <p className={styles.category}>
                                {props.wagtail.blog_categories.join(" | ")}
                            </p>
                        )}
                        <h1 className={styles.title}>{props.wagtail.title}</h1>
                        <p className={styles.metaData}>
                            {props.wagtail.post_description}
                        </p>
                    </header>
                    <BlockWidthProvider value="full">
                        {props.wagtail.body.map((block, index) => {
                            switch (block.type) {
                                case "rich_text":
                                    return (
                                        <AlignedRichText
                                            key={block.id}
                                            content={block.value}
                                            alignment="left"
                                            background_style={null}
                                        />
                                    );
                                default:
                                    return (
                                        <Toolbox
                                            block={block}
                                            key={block.id}
                                            isFirstBlock={index === 0}
                                        />
                                    );
                            }
                        })}
                    </BlockWidthProvider>
                </div>
            </div>
            <div>
                {props.wagtail.additional_body_content.map((block) => {
                    switch (block.type) {
                        case "recommended_blog_posts":
                            const tiles = block.value.posts.map((post) => {
                                return post.value;
                            });
                            return (
                                <>
                                    <BlogPostGrid
                                        tiles={tiles}
                                        title={block.value.title}
                                    />
                                    <Spacer height="xlarge" />
                                </>
                            );
                        default:
                            return (
                                <Toolbox
                                    block={block}
                                    key={block.id}
                                    isFirstBlock={false}
                                />
                            );
                    }
                })}
            </div>
            <Spacer height="xlarge" />
        </Layout>
    );
};

export default BlogPost;
